import axios from "axios";

// const route = "register/input_group";
const InputGroup = {
    namespaced: true,

    state: () => ({}),

    getters: {},

    mutations: {},
    actions: {
        transferInput(context, payload) {
            return axios.post("register/input/transfer_input", payload);
        },

        getInputsTranfer(context, { search, page, itemsPerPage }) {
            return axios.post(`helper/get_inputs_paginate?page=${page}&itemsPerPage=${itemsPerPage}`, { search });
        }
    },
};

export default InputGroup;
